export interface IZIndex {
  elementsAndComponents: {
    toggleLanguage: number;
  };
  dropdowns: {};
  headerFooter: {};
  navigation: {};
  notifications: {};
  modals: {
    modalAssignment: number;
  };
}

// Elements and Components: 0 – 99
const elementsAndComponents = {
  toggleLanguage: 110
};

// Dropdowns: 101- 199
const dropdowns = {};
// Header / Footer: 200 - 299
const headerFooter = {};
// Navigation: 300 - 399
const navigation = {};
// Notifications: 500 - 599
const notifications = {};
// Modals : 400- 499
const modals = {
  modalAssignment: 410
};
export const zIndex = {
  elementsAndComponents,
  dropdowns,
  headerFooter,
  navigation,
  notifications,
  modals
};